<!--婴幼儿管理-->
<template>
  <div class="root-container">
    <el-form ref="registerRef" label-width="120px" :rules="rules" :model="param">
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="patriarchPhone">
            <el-input
              v-model="param.patriarchPhone"
              style="width: 270px"
              placeholder=""
              readonly=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生日:" prop="birthday">
            <el-date-picker
              style="width: 270px"
              v-model="param.birthday"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="家长姓名:" prop="patriarchName">
            <el-input
              style="width: 270px"
              placeholder=""
              v-model="param.patriarchName"
              readonly=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:" prop="gender">
            <el-select
              v-model="param.gender"
              placeholder="请选择"
              style="width: 270px"
            >
              <el-option
                v-for="item in genderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:" prop="name">
            <el-input
              style="width: 270px"
              v-model="param.name"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码:">
            <el-input
              style="width: 270px"
              v-model="param.passWord"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="等级:" prop="level">
            <el-select
              placeholder="请选择"
              style="width: 270px"
              v-model="param.level"
            >
              <el-option
                v-for="item in [
                  { label: '一级', value: 1 },
                  { label: '二级', value: 2 },
                  { label: '三级', value: 3 },
                  { label: '四级', value: 4 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>
      <template v-if="param.userBuyLevels && param.userBuyLevels.length">
        <el-row v-for="(v, index) in param.userBuyLevels" :key="index">
          <el-col :span="12">
            <el-form-item label="业务等级:">
              <el-select v-model="v.lessonsId" placeholder="请选择" style="width: 270px">
                <el-option v-for="item in storeLessonsList" :disabled="param.userBuyLevels
                  .map((mk) => {
                    return Number(mk.lessonsId);
                  })
                  .includes(item.storeLessonId)
                  ? true
                  : false
                  " :key="item.storeLessonId" :label="item.name" :value="item.storeLessonId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="display: flex;align-items: center;">
            <el-form-item label="确认等级:">
              <el-select v-model="v.level" placeholder="请选择" style="width: 150px">
                <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <i class="el-icon-circle-plus" v-if="param.userBuyLevels.length - 1 == index"
              style="font-size: 25px; margin-left: 15px;cursor: pointer;color: #409eff;  margin-bottom: 22px;"
              @click="clickAdd"></i>
            <i v-else class="el-icon-remove" @click="clickDele(index)" style=" 
                  font-size: 25px;
                  cursor: pointer;
                  margin-left: 15px;
                  color: #409eff;
                  margin-bottom: 22px;
                "></i>
          </el-col>
        </el-row>
      </template>
      <el-row>
        <el-col :span="12">
          <el-form-item label="小名:" prop="petName">
            <el-input
              style="width: 270px"
              v-model="param.petName"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="渠道:" prop="source">
            <el-select
              clearable
              placeholder="请选择"
              style="width: 270px"
              v-model="param.source"
            >
              <el-option
                v-for="item in sourceOptions"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="小区:" prop="areaAddress">
        <el-input
          placeholder="请输入小区"
          v-model="param.areaAddress"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注:" prop="remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入内容"
          style="width: 665px"
          v-model="param.remark"
          maxlength="200"
        ></el-input>
      </el-form-item>
      <el-form-item label="语音备注:" prop="recording">
        <div style="width: 665px;display: flex;">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-left: 20px;">
            <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
              <source :src="audio" />
            </audio>
          </div>
        </div>
      </el-form-item>

      <!--<el-form-item label="备注信息" >-->
      <!--<el-input  style="width: 200px" v-model="createParam.remarks" placeholder=""></el-input>-->
      <!--</el-form-item>-->
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleUpdate()">保存</el-button>
    </div>
  </div>
</template>

<style></style>

<script>
import globaldata from "../../../utils/globaldata";

import commonUtils from "../../../utils/commonUtils";
import { selectChild, updateChildInfo } from "../../../api/userChild";
import messageUtils from "../../../utils/messageUtils";
import soundRecording from "@/components/soundRecording";
import enumsUtil, {
  EAllLevelOptions
} from "../../../utils/enumsUtil";
import { qlLessonTemplate } from "@/api/StoreLesson";

export default {
  name: "UpdateChildInfo",
  props: {
    childId: Number,
  },
  components: {
    soundRecording,
  },
  data() {
    return {
      rules: {
        // level: [
        //   {
        //     required: true,
        //     message: "请选择等级",
        //     trigger: "change",
        //   },
        // ],
        // source: [
        //   {
        //     required: true,
        //     message: "请选择渠道",
        //     trigger: "change",
        //   },
        // ],
        // areaAddress: [
        //   {
        //     required: true,
        //     message: "请填写小区",
        //     trigger: "blur",
        //   },
        // ],
      },
      genderOptions: [
        {
          value: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],

      param: {},

      sourceOptions: [
        { name: "自然到访(WI)" },
        { name: "电话咨询(CI)" },
        { name: "网络咨询(NI)" },
        { name: "Peferral转介绍" },
        { name: "PT带到访" },
        { name: "CO" },
        { name: "异业合作" },
      ],
      audio: '',
      levelOptions: EAllLevelOptions(),
      storeLessonsList:[]

    };
  },
  mounted() {},
  created() {
    this.initParam();
    this.getStoreLessList()
  },
  methods: {
    getStoreLessList(){
      qlLessonTemplate({
        lessonId:1,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      }).then((res) => {
        if (res.code == 20000) {
          this.storeLessonsList = res.data
        }
      })
    },
    clickAdd() {
      this.param.userBuyLevels.push({
        lessonsId: '',
        level: '',
        childId:this.param.id
      })
    },
    clickDele(ind) {
      this.$delete(this.param.userBuyLevels, ind)
    },
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    // 初始化参数
    initParam() {
      let param = {
        id: this.childId,
      };

      selectChild(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        // this.param = {
        //   name: data.name,
        //   petName: data.petName,
        //   birthday: data.birthday,
        //   gender: data.gender,
        // };
        this.param = data;
        this.audio = this.param.recording
        this.$refs.soundRecord.audio = this.param.recording
        this.$refs.soundRecord.localUrl = this.param.recording
      });
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleUpdate() {
      let param = {
        ...this.param,
        id: this.childId,
        audio:this.audio
      };

      updateChildInfo(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message);
          this.$emit("handleUpdate");
        } else {
          messageUtils.errorMsg(this, response.message);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user_child/components/UpdateChildInfo.vue